import { render, staticRenderFns } from "./canada.vue?vue&type=template&id=36a8315b&scoped=true"
import script from "./canada.vue?vue&type=script&lang=js"
export * from "./canada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a8315b",
  null
  
)

export default component.exports